var TopicCacheEntry = require('routing/topic-cache-entry');

module.exports = function DatatypeCacheEntry(details, streams, datatype) {
    TopicCacheEntry.call(this, details, streams);

    var deltaType = datatype.deltaType("binary");
    var value;

    this.handleValue = function(received, registry, errorHandler) {
        var oldValue = value;

        try {
            value = datatype.readValue(received);
            this.notifyValue(received, oldValue, value, registry);
        } catch (e) {
            errorHandler(e);
        }
    };

    this.handleDelta = function(received, registry, errorHandler) {
        var oldValue = value;

        try {
            var delta = deltaType.readDelta(received);
            value = deltaType.apply(oldValue, delta);
            this.notifyDelta(received, delta, oldValue, value, registry);
        } catch (e) {
            errorHandler(e);
        }
    };

    this.notifyValueToNewStream = function(path, details, stream) {
        if (value) {
            stream.onValue(path, details, value.$buffer, null, value);
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/routing/topic-cache-datatype-entry.js
// module id = 1007
// module chunks = 1